export default __webpack_public_path__ + "static/media/shevron-up-circle.61ec2441.svg";